import { API_BASE_URL } from "../../app/config"
import { getToken, handleSignIn } from "../iam/middleware"
import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"

/**
 * Deploy the active priority lists
 *
 * @returns {Promise<any>}
 */
export const deployActivePriorityListsToSite = async (req) => {
  let resp = await fetch(`${API_BASE_URL}/api/playlists`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(req),
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get playlists matching the provided filters
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getPlaylists = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  // Add the relevant filters
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(`${API_BASE_URL}/api/playlists?${params.toString()}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get a playlist by its ID
 * @param norad_id
 * @returns {Promise<any>}
 */
export const getPlaylistById = async (id) => {
  let resp = await fetch(`${API_BASE_URL}/api/playlists/${id}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}
